import { render, staticRenderFns } from "./ChooseLanguage.vue?vue&type=template&id=3e1a3ce8&scoped=true&"
import script from "./ChooseLanguage.vue?vue&type=script&lang=ts&"
export * from "./ChooseLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1a3ce8",
  null
  
)

export default component.exports